import { SelectProps } from 'antd';
import {
  useEmployeeDetailReducedMutation,
  useEmployeesReduced,
} from '@/core/domain/enterprise/Employees/Employees.hooks';
import { useDebounce } from '@/hooks';
import { useState } from 'react';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import useSelectOptions from '@/hooks/useSelectOptions';
import { ListEmployeesQueryReduced } from '@/core/domain/enterprise/Employees/Employees.types';

type Props = Omit<SelectProps, 'options'> & {
  companyId?: number;
  queryFilter?: ListEmployeesQueryReduced;
  employeesDisabled?: number[];
};

const EmployeesByCompanySelectField: React.FC<Props> = ({
  companyId,
  queryFilter,
  employeesDisabled,
  ...props
}) => {
  const [selectClicked, setSelectClicked] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const employeesList = useEmployeesReduced(
    {
      isActive: true,
      rows: 10,
      name: search,
      ...queryFilter,
      companyId: companyId,
    },
    selectClicked && !!companyId,
  );

  const employeeDetail = useEmployeeDetailReducedMutation();

  const employeeOptions = useSelectOptions({
    list: employeesList,
    detail: employeeDetail,
    selectProps: props,
    labelFormatter: (employee) => employee.name,
  });

  const options = employeeOptions.map((employee) => ({
    ...employee,
    disabled: employeesDisabled?.includes(Number(employee.value)),
  }));

  return (
    <InfiniteSelect
      fetchNextPage={employeesList.fetchNextPage}
      hasNextPage={employeesList.hasNextPage}
      loading={employeesList.isFetching}
      options={options}
      showSearch
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
};

export default EmployeesByCompanySelectField;
